enum JobItemType {
  INTERVENTION = 'INTERVENTION',
  OPERATION = 'OPERATION',
  PART = 'PART',
  SERVICE = 'SERVICE',
  COMMENT = 'COMMENT',
}

export default JobItemType;